import { queryOptions, useQuery } from '@tanstack/react-query';

import { apiClient } from '@cast/infrastructure-api';

type Params = {
  ruleId: string;
  enabled?: boolean;
};

const SECURITY_BEST_PRACTICES_CHECK_EXCEPTIONS_FILTERS_QUERY_KEY =
  'security-best-practices-check-exceptions-filters';

const getSaveCheckExceptionsFiltersQueryKey = (ruleId: string) =>
  [SECURITY_BEST_PRACTICES_CHECK_EXCEPTIONS_FILTERS_QUERY_KEY, ruleId] as const;

const getSaveCheckExceptionsFiltersQueryOptions = ({
  ruleId,
  enabled = true,
}: Params) =>
  queryOptions({
    queryKey: getSaveCheckExceptionsFiltersQueryKey(ruleId),
    queryFn: async () => {
      const { data } =
        await apiClient.securityInsights.getSaveCheckExceptionsFilters({
          ruleId,
        });
      return data.kinds ?? [];
    },
    enabled,
  });

export const useSaveCheckExceptionsFiltersQuery = (params: Params) => {
  const {
    isLoading,
    data: resources,
    error,
    refetch,
  } = useQuery(getSaveCheckExceptionsFiltersQueryOptions(params));

  return { isLoading, resources, error, refetch };
};
